export enum SiteTypeEnum {
    'BUILTIN_COMBO' = 'BUILTIN_COMBO',
    'TAYLOR_MADE' = 'TAYLOR_MADE',
}

